import html from "./Share.html"
import "./Share.css"
import "./ShareService.js"

var module = angular.module("ResearchKitApplicationModule");
module.component('share', {
	template: html,
	bindings: {
		"drilldownDashboardKey": "<",
		"shareTitle": '<'
	},
	controller: 'shareController',
	controllerAs: 'vm'
});

module.controller("shareController", ["$http", "$scope", "ceUrl", "shareService",
	function ($http, $scope, ceUrl, shareService) {
		var vm = this;
		vm.loading = true;

		function load() {
			vm.loading = true;
			shareService.getNetwork().then(function (result) {
				vm.network = result;
				vm.loading = false;
				if (!vm.shareFormOpen) {
					vm.shareFormOpen = vm.network.Members.length === 0;
				}
			});
		}

		vm.cancelRequest = function (request) {
			shareService.cancelRequest(request).then(load);
		};

		vm.declineRequest = function (request) {
			shareService.declineRequest(request).then(load);
		};

		vm.approveRequest = function (request) {
			shareService.approveRequest(request).then(load);
		};

		vm.revokeAccess = function (relationshipID) {
			shareService.revokeAccess(relationshipID).then(load);
		};

		vm.getMemberProfilePhotoImage = function (member) {
			return ceUrl.make('api/profilephoto/patient/' + member.PatientID + "?size=ProfileHeader");
		};

		vm.getConnectRequestSenderProfilePhotoImage = function (connectRequest) {
			return ceUrl.make('api/profilephoto/connectRequest/' + connectRequest.ID + "?size=ProfileHeader");
		};

		vm.viewNetworkMember = function (member) {
			$scope.$emit("NavigateToView", { type: "Dashboard", dashboardKey: vm.drilldownDashboardKey, patientID: member.PatientID });
		};

		vm.resendEmail = function () {
			vm.loading = true;
			$http.post(ceUrl.make('api/PatientOpenRegistration/SendVerificationEmail'))
				.finally(function () {
					vm.loading = false;
				});
		};

		vm.sendRequest = function () {
			vm.loading = true;

			shareService.sendRequest(vm.newRequestEmail, vm.newRequestType).then(function () {
				vm.finishedSharing = true;
				vm.lastSharedEmail = vm.newRequestEmail;
				vm.newRequestEmail = "";
				vm.loading = false;
				vm.error = false;
				vm.errorMessage = null;
				load();
			}).catch(function (error) {
				vm.finishedSharing = false;
				vm.error = true;
				vm.loading = false;
				vm.errorMessage = error.data;
				vm.lastSharedEmail = "";
			});
		};
		vm.newRequestEmail = '';
		vm.newRequestType = "accessAndShare";

		load();
	}
]);
